<div class="modal-groups-users-add">
  <div class="modal-groups-users-add__header">
    <div class="modal-groups-users-add__header__title">
      {{ dataTranslateUserGroups?.title }}
    </div>
    <mat-icon class="modal-groups-users-add__header__close" (click)="close()"
      >close</mat-icon
    >
  </div>
  <div class="modal-groups-users-add__content">
    <div class="modal-groups-users-add__content__add">
      <div class="modal-groups-users-add__content__add__valid-input">
        <input
          class="modal-groups-users-add__content__add__valid-input__input"
          placeholder="youremail@gmail.com"
          type="text"
          [(ngModel)]="email"
        />
      </div>
      <button
        class="modal-groups-users-add__content__add__button-add"
        (click)="validateEmail()"
        [disabled]="loading || email.length == 0"
      >
        <mat-icon>add</mat-icon>
        <span> {{ dataTranslateUserGroups?.buttonAdd }} </span>
      </button>
    </div>
    <div class="modal-groups-users-add__content__form">
      <div
        class="modal-groups-users-add__content__form__emails"
        *ngFor="let email of emailsGroups; let i = index"
      >
        <span class="modal-groups-users-add__content__form__emails__number">
          {{ i }}.
        </span>
        <div class="modal-groups-users-add__content__form__emails__email">
          <span> {{ email.email }} </span>
        </div>
        <div class="modal-groups-users-add__content__form__emails__roles">
          <mat-select
            [value]="email.status"
            placeholder="Role"
            (selectionChange)="selectionChange(i, $event)"
          >
            <mat-option *ngFor="let state of data" [value]="state">{{
              state
            }}</mat-option>
          </mat-select>
        </div>
        <mat-icon
          class="modal-groups-users-add__content__form__emails__delete"
          (click)="deleteItem(i)"
          >delete</mat-icon
        >
      </div>
    </div>
  </div>
  <div class="modal-groups-users-add__footer">
    <button
      class="modal-groups-users-add__footer__save"
      [disabled]="emailsGroups.length === 0"
      (click)="save()"
    >
      <mat-icon>send</mat-icon>
      <span>{{ dataTranslateUserGroups?.buttonSend }}</span>
    </button>
  </div>
</div>
